// extracted by mini-css-extract-plugin
export default {"footer__container":"Footer_footer__container__N6b7-","footer__item":"Footer_footer__item__q0XnZ"};